// src/redux/actions/siteActions.js
export const SET_SUPPORT_PARAM = 'SET_SUPPORT_PARAM';

export const setSupportedparamList = (supportparamList) => ({
  type: SET_SUPPORT_PARAM,
  payload: supportparamList,
});
